import { jsxs as I, jsx as i } from "react/jsx-runtime";
import { useState as N } from "react";
import { useController as k } from "react-hook-form";
import { TEST_IDS as w } from "./testIds.mjs";
import { PhoneField as D } from "./index22.mjs";
import { Stack as M } from "@mui/material";
import { OverLabel as O } from "./styles6.mjs";
import { Typography as R } from "./index59.mjs";
import { isPhoneMinimumLengthValid as U } from "./isPhoneLengthValid.mjs";
const X = ({
  control: p,
  name: r,
  defaultValue: c,
  fullWidth: n = !0,
  size: f = "small",
  helperText: g,
  labelType: l = "inside",
  label: d,
  value: a,
  onChange: v,
  onBlur: S,
  rules: x,
  ...C
}) => {
  const [s, t] = N(!1), m = l === "outside" ? d : void 0, F = l === "inside" ? d : void 0, {
    field: { onChange: L, value: V, onBlur: b, ref: B, ...y },
    fieldState: { error: P }
  } = k({
    name: r,
    control: p,
    defaultValue: c,
    rules: x
  }), T = a !== void 0 ? a : V, h = s ? P?.message : "", j = (e, o) => {
    const u = U(
      o.nationalNumber ?? "",
      o.countryCode ?? "US"
    );
    u && t(!0), s && !u && t(!1), L(e, o), v?.(e, o);
  }, E = (e) => {
    t(!0), b(), S?.(e);
  };
  return /* @__PURE__ */ I(M, { display: "inline-flex", sx: { width: n ? "100%" : "auto" }, children: [
    m && /* @__PURE__ */ i(O, { htmlFor: r, children: /* @__PURE__ */ i(R.Overline, { children: m }) }),
    /* @__PURE__ */ i(
      D,
      {
        id: r,
        fullWidth: n,
        size: f,
        error: !!h,
        label: F,
        helperText: g || h,
        "data-testid": w.phoneNumberInput,
        ...C,
        ...y,
        inputRef: B,
        value: T,
        onChange: j,
        onBlur: E
      }
    )
  ] });
};
export {
  X as FormPhoneField
};
//# sourceMappingURL=index14.mjs.map
